var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FD8469"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC6F58"
    },
    d: "M269.715,511.633c131.515-6.944,236.697-113.145,242.052-245.077L319.131,73.921l-4.344,66.003 h-88.093L123.925,265.947l83.887,83.887l-14.058,85.84L269.715,511.633z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M319.131,73.921l-35.323,18.01l17.898,35.104c-7.69-2.744-15.629-4.799-23.723-6.087 c-40.277-6.408-82.091,6.272-111.875,33.906c-30.463,28.269-46.232,69.799-42.181,111.092l39.462-3.872 c-2.85-29.043,8.249-58.259,29.689-78.155c20.926-19.416,50.329-28.322,78.677-23.812c6.268,0.996,12.407,2.646,18.327,4.887 l-35.943,18.323l18.01,35.325l95.854-48.868L319.131,73.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M349.949,256.133c0.145,21.632-7.287,42.824-20.925,59.673 c-26.109,32.254-69.327,42.655-106.189,28.777l35.914-18.31l-18.01-35.323l-95.854,48.869l48.869,95.853l35.323-18.01 l-17.853-35.016c14.198,5.06,29.212,7.671,44.516,7.671c4.725,0,9.485-0.25,14.25-0.752c35.492-3.739,67.401-21.075,89.852-48.812 c19.394-23.959,29.961-54.107,29.756-84.883L349.949,256.133z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M166.105,154.853c-30.463,28.269-46.232,69.799-42.181,111.092l39.462-3.872 c-2.813-28.667,7.985-57.487,28.882-77.362l-25.466-30.487C166.572,154.436,166.336,154.641,166.105,154.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M222.835,344.585l35.914-18.31l-18.01-35.323l-95.854,48.869l48.869,95.853l35.323-18.01 l-17.853-35.016c14.198,5.06,29.212,7.671,44.516,7.671c4.725,0,9.485-0.25,14.25-0.752c25.836-2.722,49.754-12.678,69.525-28.579 l-25.438-30.455C288.168,350.913,253.331,356.064,222.835,344.585z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.aeabd87aed0d3199e04a5477ad81de92.svg";
export { ForwardRef as ReactComponent };